var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// - Import react components
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { push } from 'react-router-redux';
import SvgClose from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItem from '@material-ui/core/ListItem';
// - Import app components
import UserAvatar from 'components/userAvatar';
// - Import API
// - Import actions
import * as notifyActions from 'store/actions/notifyActions';
var styles = function (theme) { return ({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper
    },
    closeButton: { color: 'black' },
    closeIcon: { width: 12, height: 12 },
    listItem: {
        backgroundColor: 'white',
        marginBottom: '6px'
    }
}); };
/**
 * Create component class
 */
var NotifyItemComponent = /** @class */ (function (_super) {
    __extends(NotifyItemComponent, _super);
    /**
     * Component constructor
     * @param  {object} props is an object properties of component
     */
    function NotifyItemComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSeenNotify = function (event) {
            event.preventDefault();
            var _a = _this.props, seenNotify = _a.seenNotify, id = _a.id, url = _a.url, goTo = _a.goTo, isSeen = _a.isSeen, closeNotify = _a.closeNotify;
            if (id) {
                if (!isSeen) {
                    seenNotify(id);
                }
                closeNotify();
                goTo(url);
            }
        };
        // Defaul state
        _this.state = {};
        // Binding functions to `this`
        _this.handleSeenNotify = _this.handleSeenNotify.bind(_this);
        return _this;
    }
    /**
     * Reneder component DOM
     * @return {react element} return the DOM which rendered by component
     */
    NotifyItemComponent.prototype.render = function () {
        var _a = this.props, description = _a.description, fullName = _a.fullName, avatar = _a.avatar, isSeen = _a.isSeen, id = _a.id, goTo = _a.goTo, closeNotify = _a.closeNotify, notifierUserId = _a.notifierUserId, url = _a.url, deleteNotiy = _a.deleteNotiy, classes = _a.classes;
        return (React.createElement(ListItem, { key: notifierUserId, dense: true, button: true, className: classes.listItem, style: isSeen ? { opacity: 0.6 } : {} },
            React.createElement(NavLink, { to: "/" + notifierUserId, onClick: function (evt) {
                    evt.preventDefault();
                    closeNotify();
                    goTo("/" + notifierUserId);
                } },
                React.createElement(UserAvatar, { fullName: fullName, fileName: avatar })),
            React.createElement(ListItemText, { primary: React.createElement(NavLink, { to: url, onClick: this.handleSeenNotify },
                    React.createElement("div", { className: 'user-name' }, fullName),
                    React.createElement("div", { className: 'description' }, description)) }),
            React.createElement(ListItemSecondaryAction, { className: classes.closeButton },
                React.createElement("div", { onClick: function () { return deleteNotiy(id); } },
                    React.createElement(SvgClose, { className: classes.closeIcon, style: { cursor: 'pointer' } })))));
    };
    NotifyItemComponent.propTypes = {
        /**
         * Notification description
         */
        description: PropTypes.string,
        /**
         * Which user relates to the notification item
         */
        fullName: PropTypes.string,
        /**
         * Avatar of the user who relate to the notification item
         */
        avatar: PropTypes.string,
        /**
         * Notification identifier
         */
        id: PropTypes.string,
        /**
         * If user's seen the notification or not (true/false)
         */
        isSeen: PropTypes.bool,
        /**
         * Which address notification refers
         */
        url: PropTypes.string,
        /**
         * The notifier user identifier
         */
        notifierUserId: PropTypes.string,
        /**
         * Close notification popover
         */
        closeNotify: PropTypes.func
    };
    return NotifyItemComponent;
}(Component));
export { NotifyItemComponent };
/**
 * Map dispatch to props
 * @param  {func} dispatch is the function to dispatch action to reducers
 * @param  {object} ownProps is the props belong to component
 * @return {object}          props of component
 */
var mapDispatchToProps = function (dispatch, ownProps) {
    return {
        goTo: function (url) { return dispatch(push(url)); },
        seenNotify: function (id) { return dispatch(notifyActions.dbSeenNotification(id)); },
        deleteNotiy: function (id) { return dispatch(notifyActions.dbDeleteNotification(id)); }
    };
};
/**
 * Map state to props
 * @param  {object} state is the obeject from redux store
 * @param  {object} ownProps is the props belong to component
 * @return {object}          props of component
 */
var mapStateToProps = function (state, ownProps) {
    return {};
};
// - Connect component to redux store
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(NotifyItemComponent));



//////////////////
// WEBPACK FOOTER
// ./src/components/notifyItem/NotifyItemComponent.tsx
// module id = 1093
// module chunks = 0 1 2 4 5 6 18 19 20 21